import { Checkbox, Dialog, FormControlLabel, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomButton from "../../reusableComponents/CustomButton";
import { colorBrandObject } from "../../../constants/brandings";
import { sortArrayValue } from "../utils/utils";

function CustomizeModal({
  openModal,
  onClose,
  schemaData,
  alwaysVisible,
  props,
  onApply,
}) {
  const [searchQuery, setSearchQuery] = useState("");

  const [schemaData1, setSchemaData1] = useState([]);

  useEffect(() => {
    if (alwaysVisible && alwaysVisible.length > 0) {
      let filteredFields = props?.schema?.fields.filter(
        (field) => !alwaysVisible.includes(field.name)
      );
      filteredFields = sortArrayValue(filteredFields, "header");

      setSchemaData1(filteredFields);
    } else {
      let filteredFields = [];
      if (props?.schema?.fields?.length) {
        filteredFields = sortArrayValue(filteredFields, "header");
      }

      setSchemaData1(filteredFields);
    }
  }, [props]);

  const handleCheckboxChange = (option) => {
    setSchemaData1((prevSchemaData) => {
      return prevSchemaData.map((elem) => {
        if (elem.name === option.name) {
          elem.visible = option.visible === undefined ? true : !option.visible;
        }
        return elem;
      });
    });
  };

  const handleApplyClick = () => {
    const filteredData = schemaData1.filter((option) => option.visible);
    onApply(filteredData);
    onClose();
  };

  const handleClearClick = (option) => {
    setSchemaData1(
      schemaData1.map((elem) => {
        if (elem.name !== option.name) {
          elem.visible = option.visible === undefined ? false : true;
          return elem;
        }
      })
    );
    localStorage.removeItem("CustomizedFields");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      onClose();
    }
  };

  return (
    <div>
      <Dialog
        open={openModal}
        className="orderManagementModal"
        onKeyDown={handleKeyDown}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "6px",
            padding: "24px 24px 0px 24px",
          }}
        >
          <Typography className="SemiboldTwenty font-black-highest">
            Customize Columns
          </Typography>
          <img
            src="/assets/ic_twotone-close.svg"
            alt="cross"
            onClick={() => onClose()}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Typography
          className="labelRegular font-black-high"
          style={{ padding: "0px 24px" }}
        >
          Select type
        </Typography>
        <div
          style={{
            marginTop: "20px",
            height: "282px",
            overflowY: "scroll",
            padding: "0px 24px",
          }}
        >
          <div
            className="row modalCheckbox"
            style={{
              marginLeft: "4px",
              marginRight: "0px",
            }}
          >
            {schemaData1?.map((option) => {
              if (
                searchQuery !== "" &&
                !option.header.toLowerCase().includes(searchQuery.toLowerCase())
              ) {
                return null;
              }

              return (
                <div
                  key={option.name}
                  className="col-6"
                  style={{ cursor: "pointer", width: "50%", height: "40px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: "500",
                          fontSize: "14px",
                          height: "18px",
                          color: "rgba(36, 183, 170, 1)",
                          marginRight: "8px",
                        }}
                        value={option.header}
                        checked={option.visible}
                        onChange={() => handleCheckboxChange(option)}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            color: colorBrandObject?.secondaryButtonColor,
                          },
                          "&.Mui-checked": {
                            color: colorBrandObject?.secondaryButtonColor,
                            "& .MuiSvgIcon-root": {
                              fill: colorBrandObject?.secondaryButtonColor,
                            },
                          },
                        }}
                      />
                    }
                    label={option.header}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div
          style={{
            paddingBottom: "24px",
            paddingTop: "24px",
            display: "flex",
            justifyContent: "end",
            paddingRight: "24px",
            boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
          }}
        >
          <CustomButton
            variant={"outlined"}
            size={"sm"}
            type={"secondary"}
            text={"Clear All"}
            onClick={handleClearClick}
          />
          <div style={{ marginLeft: "8px" }}>
            <CustomButton
              variant={"contained"}
              size={"sm"}
              type={"secondary"}
              text={"Apply"}
              onClick={handleApplyClick}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default CustomizeModal;
